const SectorData = [
    {
        img: '/Images/npo1.png',
        content: '68 percent of NPOs have chosen a form of entity (society/ not-for-profit company) that requires higher standards of governance and statutory reporting.'

    },
    {
        img: '/Images/npo2.png',
        content: '50 percent of NPOs in India work with less than Rs50 Lakh annual expenditure, which is about the average annual salary of an individual department head in leading industries. '

    },
    {
        img: '/Images/npo3.png',
        content: '5 states of India, Maharashtra, Tamil Nadu, Karnataka, UP and Delhi, are the primary geographic area of work for 50 percent of NPOs. 50 percent of all NPOs work locally within a state, while 20 percent have a pan India presence.'

    },
]
export { SectorData }